import { Attributes, IFormStructure } from '../ecomm-product-details-form.data';

export default (attributes: Attributes): IFormStructure => {
    switch (attributes.formName) {
        case '3-Category + Names':
            return {
                formName: 'threeCategoryNamesForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_number3: attributes.deceasedNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case '3-Category + Names + Consecration':
            return {
                formName: 'threeCategoryNamesConsecrationForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_number3: attributes.deceasedNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Amount + Category (Family or Deceased) + Names':
            return {
                formName: 'amountDeceasedNameForm',
                fields: [
                    {
                        field_name: 'amount',
                        field_type: 'radio',
                        field_options: attributes.amounts,
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number3: attributes.deceasedNames,
                        field_placeholder: '',
                        required: 'true',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_label: 'Subtotal',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Category (Family or Deceased) + Names':
            return {
                formName: 'deceasedCategoryNamesForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.deceasedNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Category + Names + Address + Contact no':
            return {
                formName: 'categoryNamesAddressForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'phone',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Category + Names + Collection or Donation':
            return {
                formName: 'categoryNamesCollectionForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'option',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Category + Names':
            return {
                formName: 'categoryNamesForm',
                fields: [
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Donation':
            return {
                formName: 'donationForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'amount',
                        field_type: 'radio',
                        field_options: attributes.amounts,
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_label: 'Subtotal',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Event dates + Category + Names':
            return {
                formName: 'eventCategoryNamesForm',
                fields: [
                    {
                        field_name: 'event',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Event dates + Names':
            return {
                formName: 'ceremonyForm',
                fields: [
                    {
                        field_name: 'event',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Event date + Name of Deceased + Dedicated by':
            return {
                formName: 'eventDeceasedDedicatedByForm',
                fields: [
                    {
                        field_name: 'event',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'deceasedName',
                        field_type: 'textBox',
                        field_placeholder: '',
                        field_number: attributes.deceasedNames,
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'dedicatedName',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Event dates + Names + NRIC + Contact Number + Address':
            return {
                formName: 'eventTaxDeductionForm',
                fields: [
                    {
                        field_name: 'event',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'tax',
                        field_type: 'checkbox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'nric',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'phone',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Name + Birth date + School name + In-person/Online':
            return {
                formName: 'nameBirthdaySchoolForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'school',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'option',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Name + Birth date + Time of birth':
            return {
                formName: 'nameBirthDatetimeForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_placeholder: '',
                        required: 'true',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Name of Deceased + Dedicated by':
            return {
                formName: 'deceasedDedicatedByForm',
                fields: [
                    {
                        field_name: 'deceasedName',
                        field_type: 'textBox',
                        field_number: attributes.deceasedNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'dedicatedName',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Names Only':
            return {
                formName: 'namesOnlyForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'No. of years + Category + Names':
            return {
                formName: 'noOfYearsCategoryNamesForm',
                fields: [
                    {
                        field_name: 'noOfYears',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'nameChange',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'period',
                        field_type: 'label',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'category',
                        field_type: 'radio',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Business':
            return {
                formName: 'servicesBusinessForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Deceased':
            return {
                formName: 'servicesDeceasedForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'dedicatedby',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Education':
            return {
                formName: 'servicesEducationForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services General':
            return {
                formName: 'servicesGeneralForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Health \u2013 Surgery':
            return {
                formName: 'servicesHealthSurgeryForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Infant Spirit':
            return {
                formName: 'servicesInfantSpiritForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Services Marriage':
            return {
                formName: 'servicesMarriageForm',
                fields: [
                    {
                        field_name: 'period',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_number: attributes.noOfNames,
                        field_number2: attributes.companyNames,
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'birthdate',
                        field_type: 'date',
                        field_placeholder: '',
                        required: 'true',
                        validation: ''
                    },
                    {
                        field_name: 'birthtime',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'building',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'unit',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'postal',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'country',
                        field_type: 'dropdown',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        case 'Name (Eng)+ Contact no. + Email Add +Date':
            return {
                formName: 'customerContactForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'contact',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'email',
                        field_type: 'textArea',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };

        default:
            return {
                formName: 'offeringForm',
                fields: [
                    {
                        field_name: 'name',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'message',
                        field_type: 'textBox',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'remark',
                        field_type: 'textArea',
                        field_placeholder: '',
                        required: 'false',
                        validation: 'string'
                    },
                    {
                        field_name: 'subtotal',
                        field_type: 'product_price',
                        field_placeholder: '',
                        required: 'false',
                        validation: ''
                    },
                    {
                        field_name: 'operation',
                        field_type: 'action',
                        field_label: '',
                        field_placeholder: '',
                        required: 'false',
                        validation: '',
                        action: 'delete_row'
                    }
                ],
                hasSerial: attributes.hasSerial
            };
    }
};
